import { UseTellescopeQueryOptions } from "../../types";
import { useTellescopeQuery } from "../../use-tellescope-query";

export interface HealthieAppoinmentType {
  created_at: string;
  id: string;
  /** Duration in minutes */
  length: number | null;
  name: string;
  updated_at: string;
  __typename: "AppointmentType";
}

export interface UseHealthieAppointmentTypesQueryOptions<TError = Error, TData = { data: HealthieAppoinmentType[] }>
  extends Omit<
    UseTellescopeQueryOptions<"integrations", "proxy_read", TError, TData>,
    "model" | "method" | "request"
  > {}

export const useHealthieAppointmentTypesQuery = <TError = Error, TData = { data: HealthieAppoinmentType[] }>(
  options: UseHealthieAppointmentTypesQueryOptions<TError, TData> = {}
) =>
  useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: {
      integration: "Healthie",
      type: "appointment-types",
    },
    ...options,
  });
